<template>
    <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('account.edit.title') }}</h3>
        </div>

        <div>
            <p style="margin-bottom: 25px;">{{ $t('account.edit.account') }}:
                <span class="pl-1">{{email ? email : '-'}}</span>
            </p>
        </div>

        <form @submit.prevent="handleOnSubmit">
            <div class="form-group row">
                <label for="first_name" class="col-sm-4 col-form-label">{{ $t('account.edit.name.first') }}</label>
                <div class="col-sm-8">
                    <input onpaste="return false" v-model="formData.first_name" type="text" id="first_name"
                        name="first_name" class="form-control" v-bind:class="{ 'is-invalid': errors.first_name }" />
                    <p class="text-size">{{ $t('auth.createUnderMessagesAube') }}</p>
                    <div v-if="errors.first_name" class="invalid-feedback invalid-errors">{{ $t('errors.' +
                        errors.first_name) }}</div>
                </div>
                <div v-if="(!errors.first_name)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="form-group row">
                <label for="last_name" class="col-sm-4 col-form-label">
                    {{ $t('account.edit.name.last') }}
                </label>
                <div class="col-sm-8">
                    <input onpaste="return false" v-model="formData.last_name" type="text" id="last_name"
                        name="last_name" class="form-control" v-bind:class="{ 'is-invalid': errors.last_name }" />
                    <p class="text-size">{{ $t('auth.createUnderMessagesAube') }}</p>
                    <div v-if="errors.last_name" class="invalid-feedback invalid-errors">{{ $t('errors.' +
                        errors.last_name) }}</div>
                </div>
                <div v-if="(!errors.last_name)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="form-group row">
                <label for="last_name" class="col-sm-4 col-form-label">{{ $t('account.edit.birthDate') }}</label>
                <div class="col-sm-8">
                    <DatePicker onpaste="return false" readonly :options="options" :selDate="formData.birth_date"
                        v-model="formData.birth_date" />
                    <div v-if="errors.birth_date" class="invalid-feedback invalid-errors">{{ $t('errors.' +
                        errors.birth_date) }}</div>
                </div>
                <div v-if="(!errors.birth_date)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="text-center">
                <div class="pb-4 ">
                    <button type="submit" class="btn btn-primary">{{ $t('account.edit.finishUpdate') }}</button>
                </div>
            </div>

            <div v-if="is_advance_member">
                <div class="text-center">
                    <router-link to="/account/deactivate-advance">
                        {{ $t('account.edit.cancelMembership') }}
                    </router-link>
                </div>
            </div>

            <div v-if="is_basic_member">
                <div class="text-center">
                    <router-link to="/account/deactivate-basic">
                        {{ $t('account.edit.cancelMembership') }}
                    </router-link>
                </div>
            </div>

            <div v-if="is_progress_member">
                <div class="text-center">
                    <router-link to="/account/deactivate-progress">
                        {{ $t('account.edit.cancelMembership') }}
                    </router-link>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import UserService from '../../services/UserService';
import DatePicker from "../../components/DatePicker";
import AuthUtil from "../../../js/utils/AuthUtil";

export default {
    name: 'edit-user-profile-module',

    components: {
        DatePicker,
    },

    data() {
        return {
            errors: this.getDefaultFields(),
            formData: this.getDefaultFields(),

            external_user_id: null,
            email: null,
            options: {
                showMonthAfterYear: true, //年月を順列に変更
                changeMonth: true,  // 月選択をプルダウン化           
                changeYear: true,   // 年選択をプルダウン化
                dateFormat: 'yy-mm-dd',//年月日
                yearRange: "1940:2000", //年 選択範囲
                monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],//月を数で表示
                dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            },
            member_type_id: 0,
            is_logged: false,
            is_advance_member: false,
            is_basic_member: false,
            is_progress_member: false,
        }
    },

    async mounted() {
        this.is_logged = AuthUtil.isAuth();

        if (this.is_logged) {
            await this.switchWithMemberType();
        }
    },

    created() {
        this.fetchUserData();
    },

    methods: {
        getDefaultFields() {
            return {
                first_name: '',
                last_name: '',
                birth_date: '',
                member_type_id: '',
            };
        },

        async handleOnSubmit() {
            this.errors = this.getDefaultFields();
            try {
                //プロフィール編集処理
                await UserService.editUserAccountComfirm({
                    ...this.formData
                });
                sessionStorage.formData = JSON.stringify(this.formData)
                this.$router.push('/account/edit-profile-confirm');
            } catch (err) {
                if (err.response.data.errors) {
                    err.response.data.errors.forEach(errItem => {
                        if (errItem.field) {
                            this.errors[errItem.field] = errItem.message[0];
                        }
                    })
                }
            }
        },

        async fetchUserData() {
            try {
                const data = (await UserService.getUserFrontendData()).data;
                this.email = data.email;
                this.member_type_id = data.member_type_id;
                this.external_user_id = data.external_user_id;
                if (sessionStorage.formData) {
                    this.formData = JSON.parse(sessionStorage.formData);
                } else {
                    this.formData.first_name = data.userData.first_name;
                    this.formData.last_name = data.userData.last_name;
                    this.formData.birth_date = data.userData.birth_date.slice(0, 10);
                }
            } catch (e) {
                this.$router.push('/registration');
            }
        },

        async switchWithMemberType() {
            this.is_advance_member = await AuthUtil.isAdvanceMemberType();
            this.is_basic_member = await AuthUtil.isBasicMemberType();
            this.is_progress_member = await AuthUtil.isProgressMemberType();
        }
    }
}
</script>

<style scoped>
.hasDatepicker {
    display: block;
    width: 100%;
    height: calc(1.6em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.form-group {
    margin-bottom: 0px;
}

.text-size {
    font-size: 10px;
}

.btn-primary:hover {
    color: #fff !important;
    background-color: #350f71 !important;
    border-color: #300e66 !important;
}

@media (min-width: 992px) {
    .col-lg-4 {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (min-width: 768px) {
    .col-md-6 {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (min-width: 576px) {
    .col-sm-12 {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

/*PC PAD用css*/
@media screen and (min-width: 479px) {

    /*ウィンドウ幅が479px以上の場合に適用*/
    .invalid-errors-hiddens {
        visibility: hidden;
        height: 77px;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .invalid-errors {
        min-height: 24px;
        height: auto !important;
        height: 24px;
        margin-top: 4px;
        margin-bottom: 4px;
    }
}

/*スマホ用css*/
@media screen and (max-width: 479px) {

    /*ウィンドウ幅が最大479pxまでの場合に適用*/
    .invalid-errors-hiddens {
        visibility: hidden;
        height: 71px;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .invalid-errors {
        min-height: 16px;
        height: auto !important;
        height: 16px;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .col-form-label {
        padding-top: 0px;
    }

    .btn-position {
        padding-top: 10px;
    }

    .text-size {
        margin-bottom: 0px;
    }
}
</style>
